<script>
import UniversalSocialauth, { Facebook, Providers } from 'universal-social-auth'

import axios from 'axios'

const options = {
    providers: {
        facebook: {
            clientId: '175788683018297',
            redirectUri: 'https://localhost:8080/login',
        },
    },
}
const socialAuth = new UniversalSocialauth(axios, options)
export default {
    name: 'SocialAuth',
    props: {
        config: null,
    },
    data() {
        return {
            responseData: {},
            hash: '',
            data: {},
            fauth: false,
            Facebook,
        }
    },
    computed: {
        facebookEnabled() {
            return !this.config.facebook_disabled
        },
    },
    methods: {
        facebook() {
            if (this.facebookEnabled) this.$user.facebookAuth()
        },
        async useAuthProvider(provider, proData) {
            const ProData = proData || Providers[provider]
            const rsp = await socialAuth.authenticate(provider, ProData)
            if (rsp.code) {
                this.responseData.code = rsp.code
                this.responseData.provider = provider
                //this.useSocialLogin()
            }
        },
        async useSocialLogin() {
            // otp from input Otp form
            // hash user data in your backend with Cache or save to database
            const pdata = {
                code: this.responseData.code,
                otp: this.data.tok,
                hash: this.hash,
            }
            const response = await axios.post(
                'https://api.diadal.com.ng/social-login/' + this.responseData.provider,
                pdata
            )
            // `response` database on your backend config
            if (response.data.status === 444) {
                this.hash = response.data.hash
                this.fauth = true // Option show Otp form incase you using 2fa or any addition security apply to your app you can handle all that from here
            } else if (response.data.status === 445) {
                //do something Optional
            } else {
                await this.useLoginFirst(response.data.u)
            }
        },
    },
}
</script>

<template lang="pug">
.social-auth
    button.btn.btn-dark.btn-block(v-if="facebookEnabled" @click="useAuthProvider('facebook', Facebook)")
        icon(icon="fa-brand fa-facebook")
        span {{$t('login.continue_facebook')}}

    .text-divider.my-8(v-if="facebookEnabled") {{$t('login.continue_email')}}
</template>
